import React from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import BlogForm from "../../reusables/BlogForm";
import { postMethod } from "../../../utils/api-service/api-service";

const CreateBlogPage = () => {

    const navigate = useNavigate();

    const handleSubmit = async (data) => {

        const formData = new FormData();

        formData.append("title", data.title);
        formData.append("description", data.description);
        formData.append("content", data.content);
        formData.append("author", data.author);
        formData.append("status", data.status);

        if (data.image) {
            formData.append("image", data.image);
        }

        const res = await postMethod(
            "/blog",
            formData,
            true
        );

        if (res.success) {
            toast.success(
                data.status === "published"
                    ? "Blog Published"
                    : "Draft Saved"
            );

            navigate("/blogs");
        }
    };

    return (
        <div className="container py-4">

            <h4 className="mb-3">
                Create Blog
            </h4>

            <BlogForm
                initialData={{
                    title: "",
                    description: "",
                    content: "",
                    author: "",
                    image: null
                }}
                onSubmit={handleSubmit}
            />

        </div>
    );
};

export default CreateBlogPage;